import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';
import {DirectoryService} from '../../../services/directory.service';

@Component({
    selector: 'role-field',
    templateUrl: 'role-field.template.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RoleFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => RoleFieldComponent), multi: true }
    ]
})
export class RoleFieldComponent extends AbstractFieldClass {
    @Input() title = '';
    @Input() tooltipText = '';
    @Input('class') valueClass = '';
    @Input() iconClass = '';

    private _listRoles;
    private _curRole;

    constructor(public directoryService: DirectoryService) {
        super();

        if (directoryService.residentOccupancyTypes.length == 0) {
            directoryService.getOccupancyTypes();
        }
    }

    public validator(value): boolean {
        return true;
    }

    listRoles() {
        return this.directoryService.residentOccupancyTypes.map(r => {
            r.class = r.code.replace('_', '-') + '-label';
            return r;
        });
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/fields/role-field/role-field.component.ts